import { AbstractControl, AsyncValidatorFn, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Observable } from 'rxjs';
import { timer } from 'rxjs/internal/observable/timer';
import { map, switchMap } from 'rxjs/operators';
import { EMPTY } from 'rxjs/internal/observable/empty';
import { ProfessionalPrivateService } from '@adeo/ngx-kozikaza-api';

export class RegistrationNumber {
  static valid(professionalPrivateService: ProfessionalPrivateService): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      return timer(500).pipe(switchMap(() => {
        if (control.value === null || control.value.length < 14) {
          return EMPTY.pipe(map(() => {
            return {registrationNumberInvalid: true};
          }));
        } else {
          return professionalPrivateService.isRegistrationNumberValid(control.value)
            .pipe(
              map((res: any) => {
                if (res.valid === true) {
                  return null;
                } else {
                  return {registrationNumberInvalid: true};
                }
              })
            );
        }
      }));
    }
  }
}
